<template>

  <feedback-modal class="dashboard-action-modal" ref="feedbackModal">

    <div class="dashboard-action-modal__message">
      <slot></slot>
    </div>

    <simple-button :text="buttonText" @click.native="handleClick" class="dashboard-action-modal__button"></simple-button>

  </feedback-modal>

</template>

<script>

import { FeedbackModal } from '@/components/common/feedbackModal'
import SimpleButton from '@/components/common/simpleButton'

export default {
  components: {
    FeedbackModal, SimpleButton
  },
  props: {
    target: Object,
    buttonText: String
  },
  methods: {
    handleClick () {
      this.$emit('click', this.target)
      this.close()
    },
    open () {
      this.$refs.feedbackModal.open()
    },
    close () {
      this.$refs.feedbackModal.close()
    }
  }
}

</script>

<style lang="scss">

.dashboard-action-modal {

  &__message {
    color: #435262;
    font-size: 17px;
    text-align: center;
  }

  &__button {
    margin: 30px auto 0 auto;
    background-color: color(red);

    &:hover {
      color: #ffffff !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// DashboardActionModal.vue?bf9ab52e